import styled from "styled-components";
import { Modal } from "components/Modal";

export const StrategyContainer = styled(Modal)`
  .modal-content {
    padding: 0;
    border: 0px;
    min-width: 559px;
    width: 559px;

    .modal-body {
      padding: 0px 0px 30px;
      margin-top: 0;

      .logo-wrapper {
        margin-top: 25px;
      }

      .content-wrapper {
        padding: 20px 30px 0px 30px;

        .heading {
          font-weight: 500;
          justify-content: center;
          display: flex;
          color: ${({ theme }) => theme.card.font.tertiary};
          text-align: center;
          font-size: 20px;
          margin-bottom: 14px;
        }

        .description {
          color: ${({ theme }) => theme.card.font.tertiary};
          text-align: center;
          font-size: 15px;
          font-weight: 400;
          align-self: stretch;
        }

        .start-button {
          justify-content: center;
          display: flex;
          width: 100%;

          button {
            width: 100%;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .modal-content {
      width: auto;
      min-width: auto;
    }
  }
`;
